<template>
    <div class="automation-action-settings">
        <div class="field">
            <label>{{ t('automations-form-actions-coupon_external-validity_label') }}</label>
            <input class="form-control" v-model="lifetime" type="tel" />
        </div>
        <div class="field">
            <label>{{ t('automations-form-actions-coupon_external-calculation_label') }}</label>
            <div>
                <label
                    ><input
                        type="radio"
                        v-model="coupon_type"
                        name="coupon_type"
                        value="fixed_amount"
                    />
                    {{ t('automations-form-actions-coupon_external-calculation_options-fixed_amount') }}
                </label>
                <label v-if="allow_percentage"
                    ><input
                        type="radio"
                        v-model="coupon_type"
                        name="coupon_type"
                        value="percentage_amount"
                    />
                    {{ t('automations-form-actions-coupon_external-calculation_options-percentage_amount') }}
                </label>
                <label
                    v-show="
                        trigger === 'new_order' ||
                        trigger === 'inactivity' ||
                        trigger === 'order_status_change'
                    "
                    ><input
                        type="radio"
                        v-model="coupon_type"
                        name="coupon_type"
                        value="cashback"
                    />
                    {{ t('automations-form-actions-coupon_external-calculation_options-cashback') }}
                </label>
            </div>
        </div>
        <div class="field" v-if="plugin === 'shopify'">
            <label>{{ t('automations-form-actions-coupon_external-discount_scope_label') }}</label>
            <select class="form-control" v-model="discount_scope">
                <option value="order">{{ t('automations-form-actions-coupon_external-discount_scope_options-order') }}</option>
                <option value="product">{{ t('automations-form-actions-coupon_external-discount_scope_options-product') }}</option>
            </select>
            <small>{{ t('automations-form-actions-coupon_external-discount_scope_help') }}</small>
        </div>
        <div class="field" v-show="coupon_type === 'fixed_amount'">
            <label>{{ t('automations-form-actions-coupon_external-fixed_amount_label') }}</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="btn btn-dark">{{ t('currency_symbol') }}</span>
                </div>
                <input
                    class="form-control"
                    name="fixed_amount"
                    v-model="fixed_amount"
                    key="fixed-amount"
                    type="text"
                    v-money="money"
                />
            </div>
        </div>
        <div class="field" v-show="coupon_type === 'percentage_amount'">
            <label>{{ t('automations-form-actions-coupon_external-percentage_amount_label') }}</label>
            <div class="input-group">
                <input
                    class="form-control"
                    name="percentage_amount"
                    v-model="percentage_amount"
                    key="percentage-amount"
                    type="text"
                    v-money="money"
                />
                <div class="input-group-prepend">
                    <span class="btn btn-dark">{{ t('percent_symbol') }}</span>
                </div>
            </div>
        </div>
        <div class="field" v-show="coupon_type === 'cashback'">
            <label>{{ t('automations-form-actions-coupon_external-cashback_percentage_label') }}</label>
            <input
                class="form-control"
                name="percentage_discount"
                v-model="percentage_discount"
                type="tel"
            />
        </div>
        <div class="field" v-show="coupon_type === 'cashback'">
            <label>{{ t('automations-form-actions-coupon_external-cashback_max_discount_label') }}</label>
            <input
                class="form-control"
                name="max_discount"
                v-model="max_discount"
                type="tel"
            />
        </div>
        <div class="field" v-show="coupon_type === 'fixed_amount' || coupon_type === 'percentage_amount'">
            <label>{{ t('automations-form-actions-coupon_external-min_purchase_label') }}</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="btn btn-dark">{{ t('currency_symbol') }}</span>
                </div>
                <input
                    class="form-control"
                    name="min_purchase_value"
                    v-model="min_purchase_value"
                    key="min-purchase-amount"
                    type="text"
                    v-money="money"
                />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        properties: Object,
        conditions: Array,
    },
    data: function () {
        return {
            title: this.t("automations-form-actions-coupon_external-title"),
            coupon_type: this.properties.coupon_type
                ? this.properties.coupon_type
                : "fixed_amount",
            description: this.t("automations-form-actions-coupon_external-description", ["[[desconto]]", "[[pedido_minimo]]"]),
            lifetime: this.properties.lifetime ? this.properties.lifetime : 14,
            fixed_amount: this.properties.fixed_amount
                ? this.properties.fixed_amount
                : 0,
            percentage_amount: this.properties.percentage_amount
                ? this.properties.percentage_amount
                : 0,
            percentage_discount: this.properties.percentage_discount
                ? this.properties.percentage_discount
                : 0,
            max_discount: this.properties.max_discount
                ? this.properties.max_discount
                : 0,
            min_purchase_value: this.properties.min_purchase_value
                ? this.properties.min_purchase_value
                : 0,
            plugin: this.properties.plugin || "tray",
            allow_percentage: this.properties.allow_percentage || false,
            discount_scope: this.properties.discount_scope || "order",
            money: {
                decimal: ".",
                thousands: "",
                prefix: "",
                suffix: "",
                precision: 2,
            },
        };
    },
    mounted: function () {
        this.$emit("mounted", this);
        this.$nextTick(() => {
            this.changed();
        });
    },
    computed: {
        trigger: function () {
            return this.$store.state.automationForm.trigger;
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        isValid: function () {
            return true;
        },
        changed: function () {
            this.$emit("propertiesUpdated", {
                lifetime: this.lifetime,
                fixed_amount: this.fixed_amount,
                percentage_amount: this.percentage_amount,
                percentage_discount: this.percentage_discount,
                max_discount: this.max_discount,
                min_purchase_value: this.min_purchase_value,
                coupon_type: this.coupon_type,
                plugin: this.plugin,
                allow_percentage: this.allow_percentage,
                discount_scope: this.plugin === "shopify" ? this.discount_scope : "order",
            });
        },
    },
    watch: {
        coupon_type: function () {
            this.changed();
        },
        lifetime: function () {
            this.changed();
        },
        fixed_amount: function () {
            this.changed();
        },
        percentage_amount: function () {
            this.changed();
        },
        percentage_discount: function () {
            this.changed();
        },
        max_discount: function () {
            this.changed();
        },
        min_purchase_value: function () {
            this.changed();
        },
        plugin: function () {
            this.changed();
        },
        discount_scope: function () {
            this.changed();
        },
    },
};
</script>
